const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  optionValueSelectionChange: 'option-value-selection-change',
  onStyleChange: 'style-change',
  onTypeChange: 'type-change',
  onPackColorsChange: 'pack-colors-change',
  onPackSizeChange: 'pack-size-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
  sectionRefreshed: 'section-refreshed',
  pdpUpdate: 'pdp-updated'
}
let subscribers = {}

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = []
  }

  subscribers[eventName] = [...subscribers[eventName], callback]

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback
    })
  }
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName].map((callback) => callback(data))
    return Promise.all(promises)
  } else {
    return Promise.resolve()
  }
}